import { ILocalization } from '../../localization/definitions/types';
import { downloadFile } from '../../services/downloadFile';
import { generateHelpFileUrl } from '../../utils/generateUrl';
import { ArrowRightIcon } from '../shared/icons/icons';

interface IProps {
    localization: ILocalization;
}

export const DataProtectionNavbarItem = ({ localization }: IProps) => {
    const { dataProtection } = localization.localizationStrings.susy.navbar;

    return (
        <div className='d-flex align-items-center justify-content-center mb-3'>
            <li
                className='susy-nav-label-data-protection-version'
                onClick={() => {
                    downloadFile(
                        generateHelpFileUrl(dataProtection.fileOriginalName),
                        dataProtection.fileOriginalName
                    );
                }}
            >
                <div className='d-flex align-items-center'>
                    <span className='susy-nav-label-data-protection-version ml-2 mr-2'>
                        {dataProtection.fileName}
                    </span>
                    <ArrowRightIcon />
                </div>
            </li>
        </div>
    );
};
